export default __webpack_public_path__ + "static/media/01OneStepAbove60s.cd80210c.mp3";